import { useTranslation } from 'react-i18next';
import { Input } from '@kognitos/lattice';
import type { NumberInputProps } from '../types';

/**
 * Number input component for numeric values
 *
 * Accepts numeric input and converts it to V1Number format on save.
 * Supports decimal numbers with proper precision handling.
 *
 * @param props - Component props
 * @returns JSX element containing the number input field
 */
export function NumberInput({
  name,
  value,
  onChange,
  error,
  required,
  placeholder,
  disabled,
}: NumberInputProps) {
  const { t } = useTranslation('automation-inputs');

  return (
    <Input
      id={name}
      name={name}
      type="number"
      step="any"
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder || t('placeholders.enter', { field: name })}
      required={required}
      aria-invalid={!!error}
      className={
        error ? 'border-destructive focus-visible:ring-destructive' : ''
      }
      disabled={disabled}
      data-testid={`input-${name}`}
    />
  );
}
